import React from 'react';

const DifficultyFilter = ({ difficulty, setDifficulty }) => {
  return (
    <div className="filter">
      <label>Difficulty: </label>
      <select value={difficulty} onChange={(e) => setDifficulty(e.target.value)}>
        <option value="All">All</option> {/* Add the 'All' option */}
        <option value="Very Easy">Very Easy</option>
        <option value="Easy">Easy</option>
        <option value="Medium">Medium</option>
        <option value="Hard">Hard</option>
        <option value="Expert">Expert</option>
      </select>
    </div>
  );
};

export default DifficultyFilter;
